import React, {
  useState,
  useEffect
} from 'react';
import { observer } from "mobx-react"

import { makeStyles } from '@material-ui/core/styles';
import {
  Avatar,
  ButtonBase,
  Chip,
  Tooltip,
  Typography,
  colors,
} from '@material-ui/core';
import { grey } from '@material-ui/core/colors';

import {
  ObservableAPI,
} from '../../../data/ObservableAPI';
import {
  User
} from '../../../types';


const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    textAlign: 'left',
  },
  avatar: {
    marginRight: 10,
  },
  nameContainer: {
    display: 'flex',
    flexGrow: 1,
    flexDirection: 'column',
  },
  line1: {
    minWidth: 120,
  },
  line2: {
    color: colors.grey[500],
  }
}));

interface PropType {
  prefix?: string;
  id?: string;
  className?: string;
  to?: string;
  component?: any;
  onClick?: () => void;
};

let reviewerCount = 1;
let reviewerIds: any = {}
function getReviewerNumber(id: string): number {
  if (!reviewerIds[id]) {
    reviewerIds[id] = reviewerCount;
    reviewerCount += 1;
  }
  return reviewerIds[id];
}

function AnonymousUserView(props: PropType) {
  const classes = useStyles();
  const prefix = props.prefix ? props.prefix : 'Reviewer';
  const reviewerNumber = props.id ? getReviewerNumber(props.id) : 1;
  
  return (
    <ButtonBase
      className={`${classes.root} ${props.className}`}
    >
      <Avatar src={undefined} className={classes.avatar} />
      <div className={classes.nameContainer}>
        <Typography variant="body1" className={classes.line1}>{prefix} {reviewerNumber}</Typography>
      </div>
    </ButtonBase>
  );
}

export {AnonymousUserView};